import { render, staticRenderFns } from "./FormButtons.vue?vue&type=template&id=ad8b6508&scoped=true"
import script from "./FormButtons.vue?vue&type=script&lang=js"
export * from "./FormButtons.vue?vue&type=script&lang=js"
import style0 from "./FormButtons.vue?vue&type=style&index=0&id=ad8b6508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad8b6508",
  null
  
)

export default component.exports